module.exports = __webpack_public_path__ + "static/media/services-item-explore-bg.4754c528.svg";